import { Stack } from '@mui/system'
import React, { useState, useEffect } from 'react'
import useDateFormatter from './hooks/useDateFormatter/useDateFormatter'

const clockStyle = {
  color: '#FFF',
  fontSize: '18px'
}

export const ClockDisplay = () => {
  const [date, setDate] = useState(new Date())
  const { formatDate } = useDateFormatter()
  useEffect(() => {
    const timer = setInterval(() => setDate(new Date()), 1000)
    return function cleanup () {
      clearInterval(timer)
    }
  })

  return (
    <Stack direction='column' alignItems='center' sx={clockStyle}>
      <div>{date.toLocaleTimeString()} </div>
      <div>{formatDate(date)}</div>
    </Stack>
  )
}

export default ClockDisplay
